import { render, staticRenderFns } from "./ServicePackageOfBranch.vue?vue&type=template&id=e8087686"
import script from "./ServicePackageOfBranch.vue?vue&type=script&lang=js"
export * from "./ServicePackageOfBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports